export const modalGrupoRegraStyles = {}
